__turbopack_context__.v({
  "rich-tooltip-label": "Tooltip-module-scss-module__1iVd3W__rich-tooltip-label",
  "rich-tooltip-subtext": "Tooltip-module-scss-module__1iVd3W__rich-tooltip-subtext",
  "tooltip": "Tooltip-module-scss-module__1iVd3W__tooltip",
  "tooltip-triangle": "Tooltip-module-scss-module__1iVd3W__tooltip-triangle",
});
